import axios from "axios";
import Config from "src/config";

const v2_actionCalendarioCriarEvento = (clienteId, data) => {
    return axios({
        method: "post",
        url: `${Config.dev ? Config.url_dev : Config.urlBackend}/api/v2/${clienteId}/calendario/eventos/criar`,
        data
    });
};
export default v2_actionCalendarioCriarEvento;
